import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { audioFiles } from '@/constants/audio';
import mitt from 'mitt'; // 컴포넌트간 통신
import store from '@/store';

//https://primevue.org/
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css';

import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';

// https://apexcharts.com/vue-chart-demos/line-charts/basic/
import VueApexCharts from 'vue3-apexcharts';

// 플러그인 import
import ConfirmPlugin from './plugins/confirm.js';
import AlertPlugin from './plugins/alert.js';

import '../src/assets/css/style.css';

const app = createApp(App);
app.provide('audioFiles', audioFiles); // 전역으로 사용

const emitter = mitt();
app.config.globalProperties.emitter = emitter;

app.use(router).use(store).use(VueApexCharts).use(ConfirmPlugin).use(AlertPlugin).mount('#app');
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none',
        },
    },
});

app.directive('tooltip', Tooltip);
app.component('ProgressSpinner', ProgressSpinner);
